// extracted by mini-css-extract-plugin
module.exports = {"blurbContainer":"collaboration-blurb_blurbContainer__hIKNl","blurbTitle":"collaboration-blurb_blurbTitle__YaQ1h","blurbDescription":"collaboration-blurb_blurbDescription__tj5cz"};